export enum PaymentTypeLabel {
  Card = 'kort',
  MobilePay = 'mobilepay',
  VippsRecurring = 'mobilepay',
  ApplePay = 'applepay',
  OneMonthBetalingsservice = '1 måned bs',
  SixMonthBetalingsservice = '6 måned bs',
  NoPaymentMethod = 'ingen betalingsmetode valgt',
}

/**
 * Human-readable payment method labels sent in the Tealium `payment_method` field
 * on purchase/receipt events. Values must match the agreed tracking spec
 * (docs/Tealium/Klasselotteriet-Tealium-Tracking-Objects.md → product_info.payment_method).
 *
 * Note: distinct from `PaymentTypeLabel` above (e.g. "kort", "1 måned bs"), which mixes the
 * payment method with the Betalingsservice interval and is used for the product `variant`.
 */
export enum PaymentMethodLabel {
  Card = 'Betalingskort',
  MobilePay = 'Mobilepay',
  Betalingsservice = 'Betalingsservice',
}

